const VAT_PERCENT_BY_ID = {
  1: null,
  2: null,
  3: 0,
  4: 5,
  5: 18,
  6: 25,
  7: 27,
  8: 20,
  9: null,
  10: 24,
  11: 9,
};

export default VAT_PERCENT_BY_ID;
